import React, { useEffect, useState } from "react";
import "../../css/BlogPost.css";
import adminpic from "../../images/seller2.jpg";
import { useNavigate, useParams } from "react-router-dom";
import axios from "axios";
import dummyImage from "../../images/no-image-thumb.jpg";
import { Helmet } from "react-helmet";
import BlogFaq from "../faq/BlogFaq";

const BlogPost = () => {
  const { slug } = useParams();
  const navigate = useNavigate();
  const [blogDetail, setBlogDetail] = useState();
  const [loading, setLoading] = useState(true);
  const [getpopularblogs, setGetPopularBlogs] = useState([]);
  const [email, setEmail] = useState("");
  const [isSubscribed, setIsSubscribed] = useState(false);
  const [error, setError] = useState("");
  const [category, setCategory] = useState([]);
  const [activeCategory, setActiveCategory] = useState("All");
  const [searchTag, setSearchTag] = useState("");
  const [tagBlogs, setTagBlogs] = useState([]);
  const [blogId, setBlogId] = useState("");
  const [faqBlogs, setFaqBlogs] = useState([]);
  const canonicalUrl = window.location.href;

  // Fetch Popular Blogs List from the API
  const fetchPopularBlogs = async () => {
    setLoading(true);
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_BASE_URL}/getPopularBlogs`
      );
      if (response.data.status === true) {
        setGetPopularBlogs(response.data.data);
      } else {
        setGetPopularBlogs([]);
      }
    } catch (error) {
      console.error("Error fetching top blogs:", error);
      setGetPopularBlogs([]);
    } finally {
      setLoading(false);
    }
  };
  // Fetch Blogs Category from the API
  const fetchBlogsCategory = async () => {
    setLoading(true);
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_BASE_URL}/getBlogsCategory`
      );
      if (response.data.status === true) {
        setCategory(response.data.data);
      } else {
        setCategory([]);
      }
    } catch (error) {
      console.error("Error fetching top blogs:", error);
      setCategory([]);
    } finally {
      setLoading(false);
    }
  };
  // Fetch Blogs Faqs List from the API
  const fetchBlogFaqs = async () => {
    if (!blogId) return;
    setLoading(true);
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_BASE_URL}/getBlogsFaqs/${blogId}`
      );
      if (response.data.status === true) {
        setFaqBlogs(response.data.data);
      } else {
        setFaqBlogs([]);
      }
    } catch (error) {
      console.error("Error fetching blog faqs:", error);
      setFaqBlogs([]);
    } finally {
      setLoading(false);
    }
  };

  const handleChange = (e) => {
    setEmail(e.target.value);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    // Simple email validation
    const emailPattern = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/;
    if (!emailPattern.test(email)) {
      setError("Please enter a valid email address.");
      return;
    }

    try {
      const response = await axios.post(
        `${process.env.REACT_APP_BASE_URL}/subscribeNewsLetter`,
        {
          email,
        }
      );

      const { status, message } = response.data;

      if (status) {
        setEmail("");
        setError("");
        setIsSubscribed(true);
      } else {
        setEmail("");
        setError(message || "Something went wrong. Please try again.");
      }
    } catch (error) {
      console.error("Subscription error:", error);

      // Handle various error status codes
      const statusCode = error.response?.status;

      let fallbackMessage = "An error occurred. Please try again later.";
      if (statusCode === 400) {
        fallbackMessage = "Email is required or invalid format.";
      } else if (statusCode === 422) {
        fallbackMessage = "Validation failed. Please check the email.";
      } else if (statusCode === 500) {
        fallbackMessage = "Internal server error. Please try again later.";
      } else if (statusCode === 404) {
        fallbackMessage = "API endpoint not found.";
      } else if (error.response?.data?.message) {
        fallbackMessage = error.response.data.message;
      }

      setError(fallbackMessage);
    }
  };
  // Fetch Blogs By Tag from the API
  const getBlogsByTag = async (tag) => {
    setLoading(true);
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_BASE_URL}/getBlogsByTag`,
        {
          params: {
            ...(tag && { tag }), // Only include category if it's not empty
          },
        }
      );

      if (response.data.status === true) {
        setTagBlogs(response.data.data);
      } else {
        setTagBlogs([]);
      }
    } catch (error) {
      console.error("Error fetching blogs:", error);
    } finally {
      setLoading(false);
    }
  };

  const handleInputChange = (e) => {
    const value = e.target.value.replace(/^#/, ""); // Remove '#' if user types it
    setSearchTag(value);
  };

  const handleSearch = () => {
    if (searchTag.trim()) {
      getBlogsByTag(searchTag.trim());
    }
  };

  const handleLinkClick = (blog) => {
    if (!blog) return;
    if (blog?.redirection_301) {
      return window.open(blog.redirection_301, "_blank");
    }
    let categorys = blog?.category_name;
    let contentType = blog?.content_type;
    // let subCategory = blog?.sub_category_name;
    let slug = blog?.slug;
    let categorySlug = `${slugify(categorys)}`;
    const url = `/${contentType}/${categorySlug}/${slug}`;

    // Open in a new tab
    window.open(url, "_blank");
  };

  function slugify(text) {
    return text
      .toLowerCase()
      .trim()
      .replace(/[\s&]+/g, "-") // replace spaces and & with hyphen
      .replace(/[^a-z0-9\-]/g, "") // remove special characters except hyphen
      .replace(/-+/g, "-"); // collapse multiple hyphens
  }

  useEffect(() => {
    const fetchData = async () => {
      if (
        slug === undefined ||
        slug === null ||
        slug === "null" ||
        slug === ""
      ) {
        navigate("/not_found", {
          state: {
            title: "Blog Detail Not Found",
            status: 404,
          },
        });
        return;
      }
      try {
        if (slug) {
          const response = await axios.get(
            `${process.env.REACT_APP_BASE_URL}/getBlogDetail/${slug}`
          );
          if (response.data.status) {
            //  alert(response.data.data.id);
            setBlogDetail(response.data.data);
            setBlogId(response.data.data.id);
            setActiveCategory(response.data.data.category_name);
          }
        }
      } catch (error) {
        console.error("API Error:", error);
        if (error.response.status === 404) {
          navigate("/not_found", {
            state: {
              title: "Blog Detail Not Found",
              status: error.response.status,
            },
          });
        } 
       else if (error.response.status === 301) {

      
    navigate(`/${error.response?.data?.redirection_url}`)
        } 
        
        else {
          navigate("/not_found", {
            state: {
              title: "Failed to Fetch Data",
              status: error.response.status,
            },
          });
        }
      }
    };
    fetchData();
    fetchBlogsCategory();
    fetchPopularBlogs();
  }, [slug]);

  useEffect(() => {
    if (blogId) {
      fetchBlogFaqs(blogId);
    }
  }, [blogId]);

  return (
    <>
      {/* Meta Details */}
      <Helmet>
        <title>{blogDetail?.meta_title}</title>
        <meta name="description" content={blogDetail?.meta_description} />
        <meta name="keyword" content={blogDetail?.meta_keyword} />
        <meta property="og:title" content={blogDetail?.meta_title} />
        <link rel="canonical" href={canonicalUrl} />
      </Helmet>

      <section className="blogpost-section">
        <div className="container">
          <div className="bigblog-mask-container">
            {/* <img src={blog1} className="target-image" /> */}
            <img
              src={blogDetail?.imagePath || dummyImage}
              className="target-image"
              style={{height:'100%'}}
              alt="Blog 1"
              onError={(e) => {
                e.target.onerror = null; // Prevent infinite loop
                e.target.src = dummyImage; // Fallback image
              }}
            />
            <div className="blogpostovrlydata">
              <div className="blogovrlydatalft">
                <div className="authorlogo">
                  <div className="authorlogo-mask-container">
                    <img src={adminpic} className="target-image" style={{height:'100%'}} />
                  </div>
                </div>
                <div className="authordata">
                  <h5>By {blogDetail?.author_name}</h5>
                  {/* <p className="dt">
                    {blogDetail?.created_at
                      ? new Date(blogDetail.created_at).toLocaleDateString(
                          "en-US",
                          {
                            year: "numeric",
                            month: "long",
                            day: "numeric",
                          }
                        )
                      : null}
                  </p> */}
                </div>
              </div>
              {/* <div className="blogovrlydatarit">
                <img src={bplike} className="bpls" />
                <img src={bpshare} className="bpls" />
              </div> */}
            </div>
          </div>
        </div>
      </section>

      <section className="blogpost-data-section sectiontopgap sectionbotgap">
        <div className="container">
          <div className="blogarea">
            <div className="leftwithblogs">
              <div className="blogmobcat mob">
                <h6>Category:</h6>
                <ul>
                  {category.map((data, index) => (
                    <li
                      key={index}
                      className={
                        activeCategory === data.category ? "active" : ""
                      }
                    >
                      <a href="#">{data.category}</a>
                    </li>
                  ))}
                </ul>
              </div>

              <div className="bptags mb-4">
                {blogDetail?.meta_keyword &&
                  blogDetail.meta_keyword.split(",").map((keyword, index) => (
                    <h6 key={index}>
                      <span>#</span>
                      {keyword.trim().charAt(0).toUpperCase() +
                        keyword.trim().slice(1)}
                    </h6>
                  ))}
              </div>
              <h2>{blogDetail?.title || ""}</h2>

              <div
                className="blogpost-data sectiontopgap sectionbotgap"
                dangerouslySetInnerHTML={{
                  __html: blogDetail?.description || "",
                }}
              ></div>
              {faqBlogs.length > 0 && (
                <div className="faqbox">
                  <BlogFaq faqBlogs={faqBlogs} />
                </div>
              )}
            </div>

            <div className="rightwithads desk">
              <div className="row">
                <div className="col-md-12 col-12">
                  <div className="ritinnbox">
                    <div className="sectiontitle mb-3">
                      <div className="titleunderline">
                        <svg
                          width="40"
                          height="3"
                          viewBox="0 0 64 3"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M2 1.5H62"
                            stroke="#F68633"
                            stroke-width="3"
                            stroke-linecap="round"
                          />
                        </svg>
                      </div>
                      <h5>Search</h5>
                    </div>

                    <div className="fb4_ob">
                      <div className="ritsearchbx">
                        <input
                          type="text"
                          value={searchTag}
                          onChange={handleInputChange}
                          placeholder="Search by #tags"
                        />
                        <button onClick={handleSearch}>
                          <svg
                            width="16"
                            height="16"
                            viewBox="0 0 38 38"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <g clip-path="url(#clip0_971_4)">
                              <path
                                fill-rule="evenodd"
                                clip-rule="evenodd"
                                d="M6.53256 27.9131C4.45695 25.7936 3.04913 23.1116 2.48376 20.1995C1.91372 17.2791 2.20644 14.2561 3.32616 11.4994C4.43633 8.75826 6.33166 6.40621 8.77416 4.73865C13.7298 1.35405 20.2537 1.35405 25.2093 4.73865C27.652 6.40621 29.5473 8.75826 30.6573 11.4994C31.7771 14.2561 32.0699 17.2791 31.4997 20.1995C30.9345 23.1116 29.5266 25.7936 27.4509 27.9131C24.7021 30.7338 20.9306 32.3248 16.9917 32.3248C13.053 32.3248 9.2814 30.7338 6.53256 27.9131Z"
                                stroke="#343434"
                                stroke-width="3.6"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                              />
                              <path
                                d="M17.0085 7.48667C16.0199 7.59141 15.3035 8.47773 15.4082 9.46631C15.513 10.4549 16.3994 11.1714 17.3879 11.0666L17.0085 7.48667ZM21.4518 13.4608C21.8394 14.3763 22.8957 14.8042 23.8113 14.4166C24.7266 14.0291 25.1546 12.9728 24.767 12.0573L21.4518 13.4608ZM28.941 26.4082C28.2376 25.706 27.0978 25.7069 26.3956 26.4106C25.6931 27.1141 25.6943 28.2538 26.3978 28.9561L28.941 26.4082ZM34.529 37.0729C35.2326 37.7753 36.3722 37.7744 37.0746 37.0707C37.7769 36.367 37.7759 35.2275 37.0722 34.525L34.529 37.0729ZM17.3879 11.0666C19.1219 10.8829 20.7722 11.855 21.4518 13.4608L24.767 12.0573C23.4693 8.99178 20.319 7.13589 17.0085 7.48667L17.3879 11.0666ZM26.3978 28.9561L34.529 37.0729L37.0722 34.525L28.941 26.4082L26.3978 28.9561Z"
                                fill="#343434"
                              />
                            </g>
                            <defs>
                              <clipPath id="clip0_971_4">
                                <rect width="38" height="38" fill="white" />
                              </clipPath>
                            </defs>
                          </svg>
                        </button>
                      </div>
                      {/* <p className="error">error</p> */}
                      {tagBlogs && tagBlogs.length > 0 ? (
                        <div style={{ maxHeight: "220px", overflow: "auto" }}>
                          <ul>
                            {tagBlogs.map((blog) => (
                              <li key={blog.id} className="search_li">
                                <div
                                  onClick={() => {
                                    handleLinkClick(blog);
                                  }}
                                  style={{cursor:'pointer'}}
                                >
                                  {blog.title}
                                </div>
                              </li>
                            ))}
                          </ul>
                        </div>
                      ) : null}
                    </div>
                  </div>
                </div>

                <div className="col-md-12 col-12">
                  <div className="ritinnbox">
                    <div className="sectiontitle mb-3">
                      <div className="titleunderline">
                        <svg
                          width="40"
                          height="3"
                          viewBox="0 0 64 3"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M2 1.5H62"
                            stroke="#F68633"
                            stroke-width="3"
                            stroke-linecap="round"
                          />
                        </svg>
                      </div>
                      <h5>Categories</h5>
                    </div>

                    <ul className="blogcats">
                      {category.map((data, index) => (
                        <li
                          key={index}
                          className={
                            activeCategory === data.category ? "active" : ""
                          }
                        >
                          <a href="#">{data.category}</a>
                        </li>
                      ))}
                    </ul>
                  </div>
                </div>

                <div className="col-md-12 col-12">
                  <div
                    className="ritinnbox"
                    style={{ height: "680px", overflow: "auto" }}
                  >
                    <div className="sectiontitle mb-3">
                      <div className="titleunderline">
                        <svg
                          width="40"
                          height="3"
                          viewBox="0 0 64 3"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M2 1.5H62"
                            stroke="#F68633"
                            stroke-width="3"
                            stroke-linecap="round"
                          />
                        </svg>
                      </div>
                      <h5>Popular Blogs</h5>
                    </div>
                    {getpopularblogs.map((data, index) => (
                      <div className="smlblog-mask-container" key={index}>
                        <div
                          onClick={() => {
                            handleLinkClick(data);
                          }}
                        >
                          <img
                            src={data.imagePath || dummyImage}
                            className="target-image"
                            onError={(e) => {
                              e.target.onerror = null; // Prevent infinite loop
                              e.target.src = dummyImage; // Fallback image
                            }}
                          />
                          <div className="blogovrlydata">
                            <h2>
                              {data.title?.split(" ").slice(0, 4).join(" ")}...
                            </h2>
                          </div>
                        </div>
                      </div>
                    ))}
                    {/* <div className="smlblog-mask-container">
                      <img src={blog2} className="target-image" />
                      <div className="blogovrlydata">
                        <h2>
                          JDA Approved Residential Plots in Kalwar Road Jaipur
                        </h2>
                      </div>
                    </div> */}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="newsletter-section sectiontopgap sectionbotgap" style={{marginBottom:'80px'}}>
        <div className="container">
          <div className="sectiontitle mb-3">
            <h1>
              Subscribe to our mailing list.
              <br />
              Join our mail list to receive our newsletter
            </h1>
            <p>
              We'll keep you up to date with our latest news, insights, free
              resources, and much more.
              <br />
              Don't worry, we won't spam you.
            </p>
          </div>

          <div className="fb4_ob">
            {!isSubscribed ? (
              <>
                <div
                  className="nlbx"
                  style={{ border: error ? "3px solid red" : "none" }}
                >
                  <input
                    type="email"
                    value={email}
                    placeholder={error ? error : "Enter Your Email Address*"}
                    onChange={handleChange}
                    className={error ? "input newslettererror" : "input"}
                    required
                  />
                  <button className="desk" onClick={handleSubmit}>
                    Subscribe Now
                  </button>
                  <button className="mob" onClick={handleSubmit}>
                    <svg
                      width="20"
                      height="20"
                      viewBox="0 0 15 15"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <g clipPath="url(#clip0_748_16863)">
                        <path
                          d="M6.45661 9.71429L8.87478 7.28936M4.62609 4.76311L10.3608 2.85154C12.9343 1.99369 14.3326 3.39866 13.4815 5.9722L11.5699 11.7069C10.2865 15.5638 8.17905 15.5638 6.89566 11.7069L6.32827 10.0047L4.62609 9.43735C0.769168 8.15396 0.769168 6.05325 4.62609 4.76311Z"
                          stroke="#F68633"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                      </g>
                      <defs>
                        <clipPath id="clip0_748_16863">
                          <rect width="20" height="20" fill="#F68633" />
                        </clipPath>
                      </defs>
                    </svg>
                  </button>
                </div>
              </>
            ) : (
              <h1
                style={{
                  color: "#fff",
                  fontWeight: 400,
                  fontSize: "24px",
                  textAlign: "center",
                }}
              >
                <i
                  class="fa fa-check-circle-o"
                  style={{ color: "green", marginRight: "10px" }}
                  aria-hidden="true"
                ></i>
                You've successfully subscribed to our newsletter!
              </h1>
            )}
            {/* {error && <span className="error">{error}</span>} */}
          </div>
        </div>
      </section>
    </>
  );
};

export default BlogPost;
